import { Link } from "gatsby"
import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import Map from "/src/components/Map"
import * as style from "./style.module.css"
import json from "/src/siteData.json"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebookSquare,
  faInstagram,
  faLine,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons"
import { faNewspaper } from "@fortawesome/free-solid-svg-icons"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"

const data = json.footer
const pageConstruct = json.pageConstruct

const Component = () => {
  return (
    <>
      {/* <Map address={data.address} /> */}
      <footer className={style.container}>
        <div className={style.site_area}>
          <Link to="/" className={style.logo}>
            <StaticImage
              src="../../images/icon/logo.png"
              alt="ロゴ画像"
              width={400}
            />
          </Link>

          <div className={style.site}>
            <ul className={style.site_list}>
              {/* {pageConstruct
                .filter(item => item.type !== 5)
                .map((item, index) => {
                  let link
                  if (item.type === 1) {
                    link = "/"
                  } else if (item.type === 4) {
                    link = `/${item.slug}/p/1`
                  } else {
                    link = `/${item.slug}`
                  }
                  return (
                    <React.Fragment key={index}>
                      {item.type === 4 && (
                        <li className={style.site_item}>
                          <Link to="/menu/">MENU</Link>
                        </li>
                      )}
                      <li className={style.site_item}>
                        <Link to={link}>{item.name}</Link>
                      </li>
                    </React.Fragment>
                  )
                })} */}

            <li className={style.site_item}>
              <Link to="/">ホーム</Link>
              </li>
            <li className={style.site_item}>
              <Link to="/concept">こだわり</Link>
            </li>
            <li className={style.site_item}>
              <Link to="/lesson">レッスン・料金</Link>
            </li>
            <li className={style.site_item}>
              <Link to="/teacher">先生の事</Link>
            </li>
            <li className={style.site_item}>
              <Link to="/eurhythmics">リトミック</Link>
            </li>
            <li className={style.site_item}>
              <Link to="/school">教室概要</Link>
            </li>
            <li className={style.site_item}>
              <Link to="/blog/p/1">お知らせ</Link>
            </li>

            <li className={style.site_item}>
              <Link to="/contact">お問い合わせ</Link>
            </li>

            </ul>
          </div>
        </div>
        <div className={style.sns}>
          <ul className={style.sns_list}>
            {/* {data.facebookUrl && (
              <li className={style.sns_item}>
                <Link to={data.facebookUrl}>
                  <FontAwesomeIcon
                    icon={faFacebookSquare}
                    style={{ fontSize: "2.2rem" }}
                    color="var(--color-dark)"
                  />
                </Link>
              </li>
            )} */}
            {data.instagramUrl && (
              <li className={style.sns_item}>
                <Link to={data.instagramUrl}>
                  <FontAwesomeIcon
                    icon={faInstagram}
                    style={{ fontSize: "2.2rem" }}
                    color="var(--color-dark)"
                  />
                </Link>
              </li>
            )}
            {data.lineUrl && (
              <li className={style.sns_item}>
                <Link to={data.lineUrl}>
                  <FontAwesomeIcon
                    icon={faLine}
                    style={{ fontSize: "2.2rem" }}
                    color="var(--color-dark)"
                  />
                </Link>
              </li>
            )}
            {/* {data.xUrl && (
              <li className={style.sns_item}>
                <Link to={data.xUrl}>
                  <FontAwesomeIcon
                    icon={faXTwitter}
                    style={{ fontSize: "2.2rem" }}
                    color="var(--color-dark)"
                  />
                </Link>
              </li>
            )} */}
            {/* {data.blogUrl && (
              <li className={style.sns_item}>
                <Link to={data.blogUrl}>
                  <FontAwesomeIcon
                    icon={faNewspaper}
                    style={{ fontSize: "2.2rem" }}
                    color="var(--color-dark)"
                  />
                </Link>
              </li>
            )} */}
          </ul>
        </div>
        {data.copyright && (
          <div className={style.nav}>
            <Link to={getPathFromTemplateType(5)}>プライバシーポリシー</Link>
            <p className={style.nav_copyright}>&copy; {data.copyright}</p>
          </div>
        )}
      </footer>
    </>
  )
}

export default Component
